module.exports = __webpack_public_path__ + "static/img/weibo.15d0b3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobiigw/weibo.png
// module id = bfSO
// module chunks = 1